module.exports = __webpack_public_path__ + "static/media/9.08237c27.jpg";